if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"payblazepayroll","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(486|884)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}